import { render, staticRenderFns } from "./AiChatMessages.vue?vue&type=template&id=2ec7f8fa&"
import script from "./AiChatMessages.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AiChatMessages.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports